import { useQuery, useMutation } from '@apollo/client';

import AgentPortalError from 'errors/AgentPortalError';

export const useManagedQuery = (query, options = {}) => {
  const { error, ...rest } = useQuery(query, options);

  if (error) {
    throw new AgentPortalError(error);
  }

  return rest;
};

export const useManagedMutation = (query, options = {}) => {
  const [mutation, { error, ...rest }] = useMutation(query, options);

  if (error) {
    throw new AgentPortalError(error);
  }

  return [mutation, rest];
};
